import Header from '../../components/Header'
import HeaderImage from '../../images/header_bg_5.jpg'
import Trainer from '../../components/Trainer'


import './trainers.css';
import axiosInstance from '../../utils/axiosInstance'
import { useEffect, useState } from 'react'
import { Email, Facebook, Instagram, Person2, Twitter, WhatsApp } from '@mui/icons-material'
import { CircularProgress } from '@mui/material'

const Traners = () => {
  const api_link = process.env.REACT_APP_API_URL;
  const [loading, setLoading] = useState(true);
  const [instructors, setInstructors] = useState([
    {
      instructor_id: 0,
      name: '',
      email: '',
      phone: '',
      speciality: '',
      avialability: '',
      hourly_rate: '',
      image_url: '',
      bio: '',
      instagram: '',
      facebook: '',
      twitter: '',
      whatsapp: '',
      createdAt: '',
    }
  ]);

  useEffect(() => {
    const getInstructors = async () => {
      setLoading(true);

      await axiosInstance.get(`instructors/all`).then((response) => {
        setLoading(false);
        setInstructors(response.data.instructors);
      }).catch((error) => {
        setLoading(false);
        if (error.response && error.response.data.message === "No instructors found") {
          setInstructors([]);
        } else if (error.response && error.response.data.message !== "No instructors found") {
          setInstructors([]);
        } else {
          setInstructors([]);
        }
      });
    }

    getInstructors();
  }, [api_link]);

  return (
    <>
      <Header title="Our Trainers" image={HeaderImage}>
        Lorem ipsum dolor sit amet consecteturrepellendus
        vero esse perspiciatis deserunt soluta, omnis nam error rem eaque quia recusandae aut?
      </Header>
      <div className='container flex items-center mt-10 text-3xl text-white gap-4'>
        <span className='bg-[#24245c] p-3 rounded-3xl px-5'><Person2 className='text-[#c7b262] text-[3rem]' /></span>
        <span className='text-[2.4rem]'>Our Trainers</span>
      </div>
      {loading ?
        <div className="flex justify-center items-center pt-20"><CircularProgress /></div>
      :
        <section className='trainers mt-12'>
          <div className="container trainers__container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
            {instructors.length > 0 &&
              instructors.map(({ instructor_id, image_url, name, email, speciality, instagram, twitter, facebook, whatsapp }) => {
                return <Trainer key={instructor_id} instructor_id={instructor_id} image={image_url} name={name} job={speciality} socials={
                  [
                    { icon: <Email />, link: `mailto:${email}` },
                    { icon: <WhatsApp />, link: `tel:${whatsapp}` },
                    { icon: <Instagram />, link: `https://www.instagram.com/${instagram}` },
                    { icon: <Facebook />, link: `https://touch.facebook.com/${facebook}` },
                    { icon: <Twitter />, link: `https://touch.facebook.com/${twitter}`}
                  ]
                } />
              })
            }
          </div>
        </section>
      }
    </>
  )
}

export default Traners